import { BarChart3, CalendarDays } from "lucide-react";

import { Button } from "~/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";
import { Separator } from "~/components/ui/separator";

import { type AnalysisViewMode, MONTH_NAMES } from "../types/salesGoals";

interface SalesGoalsHeaderProps {
  year: number;
  onYearChange: (year: number) => void;
  viewMode: AnalysisViewMode;
  onViewModeChange: (mode: AnalysisViewMode) => void;
  selectedMonth: number;
  onMonthChange: (month: number) => void;
}

export default function SalesGoalsHeader({
  year,
  onYearChange,
  viewMode,
  onViewModeChange,
  selectedMonth,
  onMonthChange,
}: SalesGoalsHeaderProps) {
  return (
    <div className="rounded-xl border bg-card p-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-xl font-bold tracking-tight sm:text-2xl">
          Metas de Venta
        </h1>

        <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
          <div className="flex overflow-hidden rounded-md border">
            <Button
              variant={viewMode === "yearly" ? "default" : "ghost"}
              size="sm"
              onClick={() => onViewModeChange("yearly")}
              className="h-9 flex-1 rounded-none border-0 px-3 sm:flex-none"
            >
              <CalendarDays className="mr-1.5 h-3.5 w-3.5" />
              Anual
            </Button>
            <Separator orientation="vertical" className="h-9" />
            <Button
              variant={viewMode === "monthly" ? "default" : "ghost"}
              size="sm"
              onClick={() => onViewModeChange("monthly")}
              className="h-9 flex-1 rounded-none border-0 px-3 sm:flex-none"
            >
              <BarChart3 className="mr-1.5 h-3.5 w-3.5" />
              Análisis Mensual
            </Button>
          </div>

          <div className="flex gap-3">
            {viewMode === "monthly" && (
              <Select
                value={selectedMonth.toString()}
                onValueChange={(v) => onMonthChange(parseInt(v))}
              >
                <SelectTrigger className="h-9 w-full sm:w-40">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {Object.entries(MONTH_NAMES).map(([num, name]) => (
                    <SelectItem key={num} value={num}>
                      {name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            )}

            <Select
              value={year.toString()}
              onValueChange={(value) => onYearChange(parseInt(value))}
            >
              <SelectTrigger className="h-9 w-full sm:w-32">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="2025">2025</SelectItem>
                <SelectItem value="2026">2026</SelectItem>
                <SelectItem value="2027">2027</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
}
